/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box } from '@mui/material';
import { LoanStatuses } from '../../../../constants/loanStatus';
import { currencyFormatterHelper } from '../../../../helpers/currencyFormatterHelper';
import { DateHelper } from '../../../../helpers/dateHelper';
import { getRiskRatingKey } from '../../../../helpers/riskRatingHelper';
import { ButtonWrapper } from '../../../../shared/components/formUtilities/useButton';


export const InitializeMyordersColumns = (t, onCancelInvestment) => {
	return [
		{
			header: t('businessName'),
			accessorKey: 'businessName',
			maxSize: 100,
		},
		{
			header: t('industry'),
			accessorKey: 'businessIndustry',
			maxSize: 100,
		},
		{
			header: t('amount'),
			accessorKey: 'amount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			maxSize: 100,
		},
		{
			header: t('riskRating'),
			accessorKey: 'rating',
			Cell: ({ cell }) => {
				return getRiskRatingKey(cell?.getValue());
			},
			maxSize: 100,
		},
		{
			header: t('type'),
			accessorKey: 'paymentFrequency',
			Cell: ({ cell }) => {
				let value = cell?.getValue();
				if (value === 0) {
					return 'Monthly';
				}
				if (value === 1) {
					return 'OneOff';
				}
			},
			maxSize: 100,
		},
		{
			header: t('profitRate'),
			accessorKey: 'investorProfit',
			Cell: ({ cell }) => {
				return `${cell?.getValue()}%`;
			},
			maxSize: 100,
		},
		{
			header: t('action'),
			accessorKey: 'actions',
			Cell: ({ cell, row }) => {
				return <Box>
					{row?.original?.loanStatus === LoanStatuses.Fundraising ?
						<ButtonWrapper labelClass='!text-[0.875rem]' classList='!py-0.5 !px-2 !border-[#ccc] !text-[#000000de]' variant={'outlined'} onClick={() => {
							onCancelInvestment && onCancelInvestment(row);
						}} label={t('cancelOrder')} /> : null}
				</Box>;
			},
			maxSize: 100,
		}
	];
};

export const InitializeRatiosColumns = (t) => {
	return [
		{
			header: t('businessName'),
			accessorKey: 'title',
			Header: ({ column }) => (
				<div style={{ maxWidth: '160px !important' }}>
					{column.columnDef.header}
				</div>
			),
			maxSize: 160,
		},
		{
			header: t('industry'),
			accessorKey: 'businessIndustry',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			size: 50,
		},
		{
			header: t('risk'),
			accessorKey: 'risk',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			size: 50,
		},
		{
			header: t('tenure'),
			accessorKey: 'tenure',
			Header: ({ column }) => <div>{column.columnDef.header}</div>,
			size: 30,
		},
		{
			header: t('repaymentsLeft'),
			accessorKey: 'repaymentsLeft',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			size: 50,
		},
		{
			header: t('investedAmount'),
			accessorKey: 'totalInvestment',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			size: 50,
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: t('amountOutstanding'),
			accessorKey: 'principalRemaining',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			maxSize: 100,
		},
		{
			header: t('nextPayment'),
			accessorKey: 'nextPaymentAmount',
			Header: ({ column }) => (
				<div
					className="data-table-header"
					style={{ maxWidth: '50px !important' }}>
					{column.columnDef.header}
				</div>
			),
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			maxSize: 50,
		},
		{
			header: t('nextPaymentDue'),
			accessorKey: 'nextPayment',
			Header: ({ column }) => (
				<div
					className="data-table-header"
					style={{ maxWidth: '120px !important' }}>
					{column.columnDef.header}
				</div>
			),
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
			maxSize: 120,
		},
		{
			header: t('profitRate'),
			accessorKey: 'investorProfit',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			Cell: ({ cell }) => {
				return `${cell?.getValue()}%`;
			},
			size: 50,
		},
		{
			header: t('status'),
			accessorKey: 'loanStatus',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			Cell: ({ cell }) => {
				return `${cell?.getValue()?.toLocaleLowerCase() !== 'paidlate'
					? cell?.getValue()
					: 'Paid'
					}`;
			},
			size: 50,
		},
		{
			header: t('agreement'),
			accessorKey: 'agreementDocumentUrl',
			Header: ({ column }) => (
				<div className="data-table-header">{column.columnDef.header}</div>
			),
			Cell: ({ cell }) => {
				return cell?.getValue() ? <a target='_blank' href={cell?.getValue()} className='flex justify-center text-center underline-link' rel="noreferrer">
					{t('viewFile')}
				</a> : null;
			},
			size: 50,
		},
	];
};
